module.exports = __webpack_public_path__ + "img/banner-servicios.6d27d3a4.jpg";